module.exports = __webpack_public_path__ + "img/air_god_bull_26_nobg_.0010_720.c6f49999.png";